export default function blogPagination() {
  const elementsPerPage = 8;
  var visibleElements = elementsPerPage;

  const blogList = document.querySelector(".blog-list");
  var showMoreBtn = blogList?.querySelector(".show-more__btn");
  const category = showMoreBtn?.getAttribute("data-category");

  if (category === "all"){
    var elements = blogList?.querySelectorAll(`.box-post`);
  } else {
    var elements = blogList?.querySelectorAll(`.box-post[data-category='${category}']`);
  }
  
  if (!showMoreBtn) return;

  if (elements.length <= elementsPerPage) { 
    showMoreBtn.classList.add("show-more__btn--hide");
    return
  };

  elements.forEach((item, index) => {
    if (index >= visibleElements) {
      item.classList.add("d-none");
    }
  });

  showMoreBtn.addEventListener("click", () => {
    visibleElements += elementsPerPage;

    elements.forEach((item, index) => {
      if (index < visibleElements) {
        item.classList.remove("d-none");
      }
    });

    if (visibleElements >= elements.length) {
      showMoreBtn.classList.add("show-more__btn--hide");
    }
  });
}
